import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { toast } from "react-toastify";
import Processing from "../../components/processing/processing";
import { useLocation, useNavigate } from "react-router-dom";
import { API } from "../../api/api";
import constants from '../../utils/contants';

const RiderDetails = () => {

    const [isEditable, setIsEditable] = useState(false);
    const [buttonValue, setButtonValue] = useState("Edit");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const { state } = useLocation();
    const { rider } = state;

    
    const getUserData = () => {
        setLoading(true);
        formik.setFieldValue("fullname", rider?.fullname);
        formik.setFieldValue("email", rider?.email);
        formik.setFieldValue("phone", rider?.phone_no);
        setLoading(false);
    };
    useEffect(() => {
        getUserData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    
    const validationSchema = Yup.object().shape({
        fullname: Yup.string().required("Please Enter Username"),
        email: Yup.string().required("Please Enter email"),
    });

    const formik = useFormik({
        initialValues: {
            fullname: "",
            email: "",
            phone: "",
        },
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            console.log("values: ", values);
            const body = {
                // id: rider?._id,
                fullname: values?.fullname,
                email: values?.email,
                phone_no: values?.phone,
            };
            API(`update-user/${rider?._id}`, "put", body, localStorage.getItem(constants.TOKEN))
                .then((res) => {
                    console.log("res: ", res);
                    toast.success("User Details updated successfully ✅", {
                        position: toast.POSITION.TOP_RIGHT,
                        className: "bg-success text-white",
                    });
                    navigate("/manage-rider");
                })
                .catch((error) => {
                    toast.error("Error while updating User Details", {
                        position: toast.POSITION.TOP_RIGHT,
                    });
                    console.log("error: ", error);
                });
        },
    });

    const enableEditing = () => {
        setIsEditable(true);
        setButtonValue("Update");
    };

    return (
        <>
            <div className="ta__dashboard">
                <div className="ta__dashboard__breadcrumb">
                    <h2 className="f-24">Manage Customers</h2>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0">
                            <li className="breadcrumb-item f-18">
                                <a href="/" className="text-gray">
                                    Home
                                </a>
                            </li>
                            <li
                                className="breadcrumb-item f-18 text-black active"
                                aria-current="page"
                            >
                                Library
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="ta__dashboard__body pb-5">
                    {loading && <Processing />}
                    {/* header */}
                    <div className="title">User Details</div>

                    <div className="advice_form text-black">
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Full Name</label>
                            <input
                                type="text"
                                name="fullname"
                                disabled={isEditable ? false : true}
                                className="form form-control bg-transparent text-black"
                                // {...formik.getFieldProps("username")}
                                value={formik.values.fullname}
                                onChange={(e) => {
                                    formik.setFieldValue("fullname", e.target.value?.trimStart())
                                }}
                            />
                            {formik.touched.fullname && formik.errors.fullname && (
                                <div className="text-danger">{formik.errors.fullname}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Email</label>
                            <input
                                type="text"
                                name="email"
                                disabled={isEditable ? false : true}
                                className="form form-control bg-transparent text-black type_password"
                                // {...formik.getFieldProps("email")}
                                value={formik.values.email}
                                onChange={(e) => {
                                    formik.setFieldValue("email", e.target.value?.trimStart())
                                }}
                            />
                            {formik.touched.email && formik.errors.email && (
                                <div className="text-danger">{formik.errors.email}</div>
                            )}
                        </div>
                        <div className="d-flex flex-column mt-3">
                            <label className="category_label">Phone No.</label>
                            <input
                                type="text"
                                name="phone"
                                disabled={isEditable ? false : true}
                                className="form form-control bg-transparent text-black"
                                // {...formik.getFieldProps("username")}
                                value={formik.values.phone}
                                onChange={(e) => {
                                    formik.setFieldValue("username", e.target.value?.trimStart())
                                }}
                            />
                            {formik.touched.phone_no && formik.errors.phone_no && (
                                <div className="text-danger">{formik.errors.phone_no}</div>
                            )}
                        </div>

                        <div className="d-flex mt-5 justify-content-end gap-4">
                            <button
                                className="form_button btn advice__category"
                                onClick={() => {
                                    window.history.back();
                                }}
                            >
                                Back
                            </button>
                            <button
                                className="form_button btn advice__category"
                                disabled={
                                    buttonValue === "Update" &&
                                    formik.values.fullname === rider?.fullname &&
                                    formik.values.email === rider.email &&
                                    formik.values.comment === rider?.comment
                                }
                                onClick={
                                    buttonValue === "Update" ? formik.handleSubmit : enableEditing
                                }
                            >
                                {buttonValue}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default RiderDetails